module.exports = __webpack_public_path__ + "static/meshkat-cover-57140750e05f542e2520674d3754cc25.jpg";